var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"outline-light","block":"","to":"/"}},[_c('b-icon-arrow-left-short'),_vm._v(" Назад ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }